(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product__main-pages"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('body').classList.add('new-styles');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty_page"] && !Shopify.designMode) return;
  try {
    
  let input = document.getElementById("purchase_date").max = new Date().toISOString().slice(0, 10);

  const productSelect = document.getElementById('product');
  const productRow = document.getElementById('product-row');
  const uvCleaningCaseRow = document.getElementById('uv-cleaning-case-row');
  const uvCleaningCaseSelect = document.getElementById('uv_cleaning_case');
  const productColourRow = document.getElementById('product-colour-row');
  const productColourSelect = document.getElementById('product_colour');
  const lotNoRow = document.getElementById('lot-no-row');
  const marketingOptInRow = document.getElementById('marketing-opt-in-row');
  const form = document.getElementById('warranty-registration-form');

  const PRO_COLOURS = [
    'Winter Fern',
    'Sunset Bloom',
    'Canyon Sunrise',
    'Sea Mist',
    'Midnight Black',
    'Morning Waves',
  ];
  const CORE_COLOURS = [
    'Ember',
    'Moonrise',
    'Nightfall',
    'Haze',
  ];

  const setColourOptions = (colours, selectedValue = '') => {
    if (!productColourSelect) return;

    productColourSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a colour';
    productColourSelect.appendChild(placeholder);

    colours.forEach((colour) => {
      const option = document.createElement('option');
      option.value = colour;
      option.textContent = colour;
      if (colour === selectedValue) option.selected = true;
      productColourSelect.appendChild(option);
    });
  };

  const updateProductConditionalFields = () => {
    const product = productSelect?.value || '';
    const isProToothbrush = product === 'SURI Pro Sonic Toothbrush';
    const isCoreToothbrush = product === 'SURI Core Sonic Toothbrush';
    const isToothbrush = isProToothbrush || isCoreToothbrush;
    const isBrushHeads = product === 'SURI Brush Heads';
    const isToothbrushOrHeads = isToothbrush || isBrushHeads;
    const previousColour = productColourSelect?.value || '';

    if (isProToothbrush) {
      setColourOptions(PRO_COLOURS, PRO_COLOURS.includes(previousColour) ? previousColour : '');
    } else if (isCoreToothbrush) {
      setColourOptions(CORE_COLOURS, CORE_COLOURS.includes(previousColour) ? previousColour : '');
    } else if (isBrushHeads) {
      setColourOptions(
        [...PRO_COLOURS, ...CORE_COLOURS],
        [...PRO_COLOURS, ...CORE_COLOURS].includes(previousColour) ? previousColour : ''
      );
    } else {
      setColourOptions([]);
    }

    if (uvCleaningCaseRow && uvCleaningCaseSelect) {
      uvCleaningCaseRow.style.display = isProToothbrush ? 'flex' : 'none';
      uvCleaningCaseSelect.required = isProToothbrush;
      if (!isProToothbrush) uvCleaningCaseSelect.value = '';
    }

    if (productColourRow && productColourSelect) {
      productColourRow.style.display = isToothbrushOrHeads ? 'flex' : 'none';
      productColourSelect.required = isToothbrushOrHeads;
      if (!isToothbrushOrHeads) productColourSelect.value = '';
    }

    if (form && marketingOptInRow) {
      const fieldOrder = isProToothbrush
        ? [productRow, uvCleaningCaseRow, productColourRow, lotNoRow]
        : isCoreToothbrush || isBrushHeads
          ? [productRow, productColourRow, lotNoRow, uvCleaningCaseRow]
          : [productRow, lotNoRow, uvCleaningCaseRow, productColourRow];

      fieldOrder.forEach((row) => {
        if (row) form.insertBefore(row, marketingOptInRow);
      });
    }
  };

  if (productSelect) {
    productSelect.addEventListener('change', updateProductConditionalFields);
    updateProductConditionalFields();
  }

  // Google Maps Places
  const googleMapsScript = document.createElement('script');
  googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCHhBiXn9t67jW__mzfcr3jDkzO14lr5n0&libraries=places&callback=initAutocomplete`;
  googleMapsScript.defer = true;
  googleMapsScript.async = true;
  document.head.appendChild(googleMapsScript);

  window.initAutocomplete = function () {
    const input = document.getElementById('address_line_1');
    if (input) {
      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['address']
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.address_components) return;

        const getComponent = (type) =>
          place.address_components.find(c => c.types.includes(type))?.long_name || '';
        const getShort = (type) =>
          place.address_components.find(c => c.types.includes(type))?.short_name || '';

        const streetNumber = getComponent('street_number');
        const route = getComponent('route');
        document.getElementById('address_line_1').value = `${streetNumber} ${route}`.trim();

        document.getElementById('address_line_2').value = '';
        document.getElementById('city').value = getComponent('locality') || getComponent('postal_town');
        document.getElementById('region').value = getComponent('administrative_area_level_1');
        document.getElementById('postcode').value = getComponent('postal_code');
        document.getElementById('country').value = getComponent('country');

        showAllFields();
      });
    }
  };

  // Handle form submission with reCAPTCHA v3 (invisible)
  const messageContainer = document.getElementById('form-message');

  if (form && messageContainer) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      messageContainer.innerHTML = '';

      grecaptcha.ready(function () {
        grecaptcha.execute('6LcjxgguAAAAANbDK5mfjImK1u7lQSSjRHLa-rZH', { action: 'submit' }).then(async function (token) {
          const formData = new FormData(form);
          const data = Object.fromEntries(formData.entries());
          data["g-recaptcha-response"] = token;

          try {
            const response = await fetch('https://suri-api.vercel.app/api/forms/warranty', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            });

            if (response.ok) {
              // messageContainer.style.color = 'green';
              // messageContainer.innerText = 'Thank you! Your warranty has been registered.';
              form.style.display = 'none';
              const thankYouDiv = document.querySelector('.thank-you');
              thankYouDiv.style.display = 'flex';
              form.reset();
              updateProductConditionalFields();

              // Build body for /api/google/warranty-email
              const warrantyEmailPayload = {
                email: data.email,
                name: [data.first_name, data.last_name].filter(Boolean).join(' ').trim(),
                product: data.product,
                serial: data.lot_no,
                purchaseDate: data.purchase_date,       // already YYYY-MM-DD from <input type="date">
                purchaseLocation: data.purchase_location
              };

              // Fire and forget (don’t block UX on email send)
              try {
                await fetch('https://suri-api.vercel.app/api/google/warranty-email', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(warrantyEmailPayload)
                });
              } catch (err) {
                console.warn('Warranty email send failed:', err);
              }
            } else {
              const errorData = await response.json();
              throw new Error(errorData.message || 'An error occurred while submitting the form.');
            }
          } catch (error) {
            messageContainer.style.color = 'red';
            messageContainer.innerText = error.message;
          }
        });
      });
    });
  }

  const lotNoBtn = document.querySelector('.lot_no_button');
  const lotNoModal = document.querySelector('.washbag-modal--lotno');
  if (lotNoBtn && lotNoModal) {
    console.log("watching");
    lotNoBtn.addEventListener('click', (e) => {
    console.log("clicked");
      e.preventDefault();
      lotNoModal.classList.remove('hidden');
      lotNoModal.setAttribute('aria-hidden', 'false');
    });
  }

  const navButtons = document.querySelectorAll('.warranty-nav-btn');
  navButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = button.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);
      const allNavSections = document.querySelectorAll('.warranty-nav-item');

      allNavSections.forEach(section => section.style.display = 'none');
      navButtons.forEach(btn => btn.classList.remove('active'));

      if (targetSection) {
        button.classList.add('active');
        targetSection.style.display = 'block';
      }
    });
  });

  // Modified: Only one quick-start-step open at a time
  const quickStartSteps = document.querySelectorAll('.quick-start-step');
  quickStartSteps.forEach(step => {
    step.addEventListener('click', () => {
      // Close all steps
      quickStartSteps.forEach(s => {
        s.classList.remove('active');
        const icon = s.querySelector('.gicon.right');
        if (icon) {
          icon.classList.remove('gicon--minus');
          icon.classList.add('gicon--plus');
        }
      });
      // Open the clicked step
      step.classList.add('active');
      const icon = step.querySelector('.gicon.right');
      if (icon) {
        icon.classList.remove('gicon--plus');
        icon.classList.add('gicon--minus');
      }
    });
  })

  } catch(e) { console.error(e); }
})();
})();
